// extracted by mini-css-extract-plugin
export var integrationButton = "_99-0";